import { IconLanguage } from '@components/icons/language';

import { useStore } from 'models/stores';

import EmptyStateCard from './EmptyStateCard';

function LanguageDataNotAvailable() {
  const { uiStore } = useStore();
  return (
    <EmptyStateCard
      icon={<IconLanguage />}
      heading={uiStore.t('job_list_no_language_data')}
      sub={uiStore.t('job_list_no_language_data_sub')}
    />
  );
}

export default LanguageDataNotAvailable;
